// Low-tech hero: if src is empty/missing, renders a styled text-only color tile
// with big serif title. No stock photo needed.

export default function HeroImage({ src, title, className = "", eyebrow = "recipe" }) {
  if (src && src.trim()) {
    return <img src={src} alt={title} className={className} />;
  }
  return (
    <div
      data-testid="hero-image-fallback"
      className={`${className} flex items-center justify-center p-8 text-center relative overflow-hidden`}
      style={{
        background:
          "radial-gradient(circle at 30% 20%, hsl(var(--primary) / 0.9), hsl(var(--accent)) 60%, hsl(var(--accent) / 0.85))",
      }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="relative z-10 max-w-3xl">
        <p className="font-script text-background text-2xl md:text-3xl mb-3 opacity-95">{eyebrow}</p>
        <p className="font-display text-background text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tighter">
          {title}
        </p>
      </div>
    </div>
  );
}
